import { render, staticRenderFns } from "./ExclamationDiamondFill.vue?vue&type=template&id=384907d1"
import script from "./ExclamationDiamondFill.vue?vue&type=script&lang=js"
export * from "./ExclamationDiamondFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports